import * as React from 'react';
import { durationUnits, splitDays } from 'infrastructure/duration';
import { Translate } from 'infrastructure/mapping/Translate';
import { Translations } from 'models/Translations';

interface IProps {
    id: string;
    days: number;
    onChange: (days: number) => void;
    translations: Translations;
    required?: boolean;
}

interface IState {
    amount: number;
    factor: number;
}

// enters a number of days as amount + unit, e.g. 2 years
export class DurationInput extends React.Component<IProps, IState> {
    // the unit lives in state, so it doesn't jump while typing (e.g. 14 days would turn into 2 weeks)
    public readonly state: IState = splitDays(this.props.days);

    change(amount: number, factor: number) {
        this.setState({ amount, factor });
        this.props.onChange(isNaN(amount) ? NaN : amount * factor);
    }

    render() {
        return (
            <div className='c-form__duration'>
                <input className='c-form__control'
                    id={this.props.id}
                    type='number'
                    min={0}
                    step={1}
                    required={this.props.required}
                    value={isNaN(this.state.amount) ? '' : this.state.amount}
                    onChange={e => this.change(e.currentTarget.value === '' ? NaN : Number(e.currentTarget.value), this.state.factor)}
                    autoComplete='off'
                />
                <select className='c-form__control'
                    aria-label={Translate.text(this.props.translations, 'Unit')}
                    value={this.state.factor}
                    onChange={e => this.change(this.state.amount, Number(e.currentTarget.value))}
                >
                    {durationUnits.map(u =>
                        <option key={u.factor} value={u.factor}>{Translate.text(this.props.translations, u.name)}</option>
                    )}
                </select>
            </div>
        );
    }
}
